// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidItemAttributesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BidItemAttributesQuery = { __typename?: 'Query', costTypes: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }> };


export const BidItemAttributesDocument = gql`
    query BidItemAttributes {
  costTypes {
    code
    name
  }
}
    `;

/**
 * __useBidItemAttributesQuery__
 *
 * To run a query within a React component, call `useBidItemAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidItemAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidItemAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBidItemAttributesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidItemAttributesQuery, BidItemAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidItemAttributesQuery, BidItemAttributesQueryVariables>(BidItemAttributesDocument, options);
      }
export function useBidItemAttributesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidItemAttributesQuery, BidItemAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidItemAttributesQuery, BidItemAttributesQueryVariables>(BidItemAttributesDocument, options);
        }
// @ts-ignore
export function useBidItemAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidItemAttributesQuery, BidItemAttributesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemAttributesQuery, BidItemAttributesQueryVariables>;
export function useBidItemAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemAttributesQuery, BidItemAttributesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemAttributesQuery | undefined, BidItemAttributesQueryVariables>;
export function useBidItemAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemAttributesQuery, BidItemAttributesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidItemAttributesQuery, BidItemAttributesQueryVariables>(BidItemAttributesDocument, options);
        }
export type BidItemAttributesQueryHookResult = ReturnType<typeof useBidItemAttributesQuery>;
export type BidItemAttributesLazyQueryHookResult = ReturnType<typeof useBidItemAttributesLazyQuery>;
export type BidItemAttributesSuspenseQueryHookResult = ReturnType<typeof useBidItemAttributesSuspenseQuery>;
export type BidItemAttributesQueryResult = ApolloReactCommon.QueryResult<BidItemAttributesQuery, BidItemAttributesQueryVariables>;